<h1>Fehler in Version 2.2 - Sprachumschaltung</h1>
<section class="article">
    <article>
        <div class="text">
            <p>Leider ist uns in der Version 2.2.0 ein Fehler unterlaufen.
                Die Umstellung der Sprache der Benutzeroberfläche von video2manual über den
                Optionen-Dialog funktioniert nicht mehr. Im Folgenden zeigen wir Ihnen, 
                wie Sie das Problem umgehen können.
            </p>
            <p>Selbstverständlich wird der Fehler kurzfristig (in Version 2.2.1) behoben sein.
            </p>
        </div>
        <h3>Umstellung mit dem Registrierungs-Editor</h3>
        <p>Hinweis: Für diese Vorgehensweise benötigen Sie Administrator-Rechte auf Ihrem System.
            Holen Sie sich bei Bedarf Hilfe bei Ihrem System-Administrator.
        </p>
        <p>Unter Windows steht Ihnen das Programm Registrierungs-Editor zur Verfügung, mit dem
            Sie die Einstellungen von video2manual manuell vornehmen können.
        </p>
        <p>Öffnen Sie dazu den Dialog zur Ausführung von Programmen (mit der Tastaturkombination Win+R) 
            und geben Sie den Text "regedit" ein.</p>
        <img class="screenshot" src="assets/run_dlg.png" style="width: 400px;" />
        <p>Klicken Sie auf OK. Bestätigen Sie den folgenden Sicherheitshinweis.</p>
        <img class="screenshot" src="assets/reg_edit_1.png" alt="Registrierungs-Editor" style="width: 1000px;">
        <p>Öffnen Sie auf der linken Seite den Pfad HKEY_CURRENT_USER\Software\ISB\video2manual 
            (wie in der Abbildung gezeigt).</p>
        <p>Prüfen Sie, ob auf der rechten Seite ein Eintrag "UserInterfaceLanguage" existiert.</p>
        <p>Existiert der Eintrag noch nicht, legen Sie bitte einen neuen Eintrag über das Menü Bearbeiten > Neu > Zeichenfolge an.</p>
        <p>Klicken Sie dann doppelt auf den Eintrag und geben Sie als Wert "de" für deutsch bzw. 
            "en" für englisch ein und bestätigen Sie mit OK.</p>
        <img class="screenshot" src="assets/regedit_lang.png" style="width: 400px;" />
        <p>Sie können video2manual jetzt neu starten. Es sollte in der ausgewählten Sprache erscheinen.</p>
        <p>Den Registrierungs-Editor benötigen Sie nicht mehr. Sie können ihn schließen.</p>
        <h3>Einspielen von reg-Dateien</h3>
        <p>Der oben beschriebene Vorgang kann verkürzt werden, wenn Sie die reg-Dateien benutzen, die wir
            Ihnen hier zur Verfügung stellen.</p>
        <p>Weil das Herunterladen von reg-Dateien auf vielen Systemen (aus gutem Grund) nicht erlaubt ist, 
            haben wir die Daten als reine Text-Dateien (Endung .txt) zur Verfügung gestellt. Um sie zu nutzen,
            müssen Sie die Dateien beim oder nach dem Herunterladen in .reg-Dateien umbenennen.
        </p>
        <p>Klicken Sie mit der rechten Maustaste auf den entsprechenden Link und wählen Sie "Link speichern unter ..."</p>
        <p>Speichern Sie die Datei mit der Dateiendung .reg auf Ihrem Rechner. Durch einen Doppelklick auf die reg-Datei und die Bestätigung
            der darauf erscheinenden Hinweise und Fragen, wird der notwendige Eintrag in Ihrer Registry automatisch vorgenommen.
        </p>
        <p>Umschalten auf die englische Sprache -> <a href="assets/SwitchToEnglish.txt">SwitchToEnglish.reg</a></p>
        <p>Umschalten auf die deutsch Sprache -> <a href="assets/SwitchToGerman.txt">SwitchToGerman.reg</a></p>
    </article>
</section>
